import { Routes } from '@angular/router';
import { PanTokenizationComponent } from './views/pan-tokenization/pan-tokenization.component';
import { PaymentComponent } from './views/payment/payment.component';
import { PanTokenizationPrnComponent } from './views/pan-tokenization-prn/pan-tokenization-prn.component';

export const routes: Routes = [
  { path: 'payment', component: PaymentComponent },
  { path: 'pan-token-generation', component: PanTokenizationComponent },
  { path: 'pan-token-generation-prn', component: PanTokenizationPrnComponent }
];
